import React, { useCallback, useState, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  DirectionsService,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { useData } from "../../context/GetDataContext";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: 28.6139,
  lng: 77.209,
};

//const origin = { lat: 28.7041, lng: 77.1025 }; // Delhi

const MapRoute = () => {
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distanceKm, setDistanceKm] = useState(null);
  const [distanceMiles, setDistanceMiles] = useState(null);
  const [isDirectionsLoaded, setIsDirectionsLoaded] = useState(false);

  const { data } = useData();
  console.log(data?.consignee);
  console.log(data?.shipper);

  const origin = {
    lat: Number(data?.shipper?.lat),
    lng: Number(data?.shipper?.lng),
  }; // Delhi

  const destination = {
    lat: Number(data?.consignee?.lat),
    lng: Number(data?.consignee?.lng),
  }; // Gurgaon

  const directionsCallback = useCallback(
    (response: any) => {
      if (response && response.status === "OK" && !isDirectionsLoaded) {
        setDirectionsResponse(response);
        const meters = response.routes[0].legs[0].distance.value;
        const km = meters / 1000;
        const miles = km * 0.621371;
        setDistanceKm(km.toFixed(2) as any);
        setDistanceMiles(miles.toFixed(2) as any);
        setIsDirectionsLoaded(true);
      }
    },
    [isDirectionsLoaded],
  );

  // Use useEffect to prevent the infinite loop
  useEffect(() => {
    if (!directionsResponse) {
      // You can add a condition here if you want to re-calculate directions
      // based on changes to origin or destination.
      // For now, it will only calculate once on initial render.
      // The DirectionsService component will be rendered inside the map
      // and will call the callback only once because of the `isDirectionsLoaded` state.
    }
  }, [directionsResponse]);

  return (
    <div>
      {" "}
      {/* Replace with your API key */}
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={11}>
        {!directionsResponse && (
          <DirectionsService
            options={{
              destination,
              origin,
              travelMode: google.maps.TravelMode.DRIVING,
            }}
            callback={directionsCallback}
          />
        )}
        {directionsResponse && (
          <DirectionsRenderer directions={directionsResponse} />
        )}
      </GoogleMap>
      {/* Distance display */}
      {distanceKm && distanceMiles && (
        <div style={{ padding: "1rem 0", fontSize: "18px" }}>
          <strong>Distance:</strong> {distanceKm} km / {distanceMiles} miles
        </div>
      )}
    </div>
  );
};

export default MapRoute;
